// src/store/StoreProvider.tsx
import { ReactNode, useMemo, useReducer } from 'react'
import { contextConfigs } from './contextList'
import { LoadingProvider } from './loadingContext'
import { LoginProvider } from './loginContext'
import { PayCenterProvider } from './payCenterContext'
import { PlatformModalProvider } from './platformModalContext'
interface StoreProviderProps {
  children: ReactNode
}

const StoreProvider = ({ children }: StoreProviderProps): JSX.Element => {
  const contexts = contextConfigs.map(({ Context, reducer, initialState }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const value = useMemo(() => ({ ...state, dispatch }), [state])
    return { Context, value }
  })

  const nestedProviders = contexts.reduceRight((acc, { Context, value }) => {
    const Provider = Context.Provider
    return <Provider value={value}>{acc}</Provider>
  }, children)

  return (
    <>
      {
        <LoadingProvider>
          <LoginProvider>
            <PayCenterProvider>
              <PlatformModalProvider>{nestedProviders}</PlatformModalProvider>
            </PayCenterProvider>
          </LoginProvider>
        </LoadingProvider>
      }
    </>
  )
}

export default StoreProvider
